import React from 'react'
import { Oval } from 'react-loader-spinner'

const LoadingGreen = ({ size = "45", height = "100px", paddingTop = "10vh" }) => {
    return (
        <div>
            <div
                className="d-flex justify-content-center "
                style={{ height: height, paddingTop: paddingTop }}
            >
                <Oval
                    height={size}
                    width={size}
                    color="#4fa94d"
                    secondaryColor="#4fa94d"
                />
            </div>
        </div>
    )
}

export default LoadingGreen